import React from 'react'
import { SimpleTooltip } from '../simple-tooltip'
import { mergeClasses } from '@/helpers/styling'

/** Forwards its ref to the button, so it can be a Radix trigger (`<DropdownMenuTrigger asChild>`) */
export const MiniButton = React.forwardRef<HTMLButtonElement, {
  title?: string
  className?: string
  children: React.ReactNode
} & React.ButtonHTMLAttributes<HTMLButtonElement>>(function MiniButton(props, ref) {
  const { title, className, children, ...buttonProps } = props
  return (
    <SimpleTooltip tooltip={title} delayDuration={700}>
      <button
        ref={ref}
        title={title}
        type={props.type ?? "button"}
        className={mergeClasses(
          `inline-flex p-1 items-center justify-center
          hover:text-black hover:bg-gray-200`,
          className)}
        {...buttonProps}
      >
        {children}
      </button>
    </SimpleTooltip>
  )
})
